module.exports = __webpack_public_path__ + "static/conflict_card_img4@2x-45ddd9d25f2b5aae9e70b698ab654488.jpg";